export interface SearchProjectForm {
  keyword_search?: string;
  status?: string;
  projectName?: string;
  project_id?: string;
  clientId?: string;
  fromDate?: string;
  toDate?: string;
  /** Pass "1" for Today active tasks filter */
  activeStatus?: string;
  /** Pass "2" for In Progress, "4" for Completed */
  task_status?: string;
}

export interface AddProject {
  project_name: string;
  project_shortname: string;
  client_id: string;
  sub_client_id: string;
  po_number: string;
  project_contact: string;
  project_activity: ProjectActivityType[];
  project_total_amount: string;
  project_quotation: string;
  project_start_date: Date | string;
  project_end_date: Date | string;
  project_manager_id: string;
  project_description: string;
  budget_hours: string;
  project_id: string;
  project_status: string;
  contact_id: string;
  project_type?: string;
}

export interface ProjectActivityType {
  type: string;
  resource_id: string;
  amount: string;
  hours: string;
}

export interface ProjectActivityDetail {
  activity_id: string;
  project_id: string;
  activity_name: string;
  activity_hours: string;
  activity_amount: string;
  createdBy: string;
  createdOn: Date | string;
  category_name: string;
  resource_id: string;
}
export interface ProjectActivityListDetail {
  categoryType: {
    module_cat_createdate: Date | string;
    module_cat_parent_id: string;
    module_cat_shorttitle: string;
    module_cat_status: string;
    module_cat_title: string;
    module_cat_updatedate: Date | string;
    module_category_id: string;
  }[];
  module_cat_createdate: Date | string;
  module_cat_parent_id: string;
  module_cat_shorttitle: string;
  module_cat_status: string;
  module_cat_title: string;
  module_cat_updatedate: Date | string;
  module_category_id: string;
}

export interface ProjectListDetail {
  client_id: string;
  clientname: string;
  closedby_userid: string;
  customer_id: string;
  manager_id: string;
  pr_archive: string;
  pr_budget_category: string;
  pr_budgeted_amount: string;
  pr_budgeted_hours: string;
  pr_closed_date: Date | string;
  pr_comments: string;
  pr_contact_number: string;
  pr_creation_date: Date | string;
  pr_currency_track_id: string;
  pr_end_date: Date | string;
  pr_last_modified: string;
  pr_name: string;
  pr_po_number: string;
  pr_quotation: string;
  pr_short_name: string;
  pr_start_date: Date | string;
  project_id: string;
  projectmanager_name: string;
  status: string;
  sub_clientid: string;
  updatedby_userid: string;
  user_id: string;
  limit?: number;
  offset?: number;
  total_records?: number;
}

export interface ProjectDetail {
  client_id: string;
  clientname: string;
  closedby_userid: string;
  customer_id: string;
  manager_id: string;
  pr_archive: string;
  pr_budget_category: string;
  pr_budgeted_amount: string;
  pr_budgeted_hours: string;
  pr_closed_date: Date | string;
  pr_comments: string;
  pr_contact_number: string;
  pr_creation_date: Date | string;
  pr_currency_track_id: string;
  pr_end_date: Date | string;
  pr_last_modified: string;
  pr_name: string;
  pr_po_number: string;
  pr_quotation: string;
  pr_short_name: string;
  pr_start_date: Date | string;
  projectmanager_name: string;
  status: string;
  sub_clientid: string;
  subclient_name: string;
  updatedby_userid: string;
  user_id: string;
  project_id: string;
  activity_type: ProjectActivityDetail[];
  brandmanager_id: string;
  contactEmail: string;
  contactMobile: string;
  contact_id: string;
  project_type?: string;
}

export interface ProjectType {
  id: string;
  project_type: string;
  status?: string;
  createdDate?: string;
}

export interface AssignedResource {
  resourceFirstName: string;
  resourceLastName: string;
  [key: string]: any;
}
export interface ProjectsListReport {
  project_id: string;
  project_name: string;
  project_start_date: string;
  project_status: string;
  resourceFullName: string;
  assignedResources: AssignedResource[];
  keyword_search?: string,
  limit?: number;
  offset?: number;
  total_records?: number;
}

export interface GenerateProjectReport {
  activityId?: string,
  reportfromDate?: string,
  reporttoDate?: string
}
